module.exports = __webpack_public_path__ + "media/images/home/cover-img-mobile-af22a93024d1c1a87fbf08eb0cf4aa5d.jpg";